import { WebChatProvider } from './context';
import Bubble from './components/Bubble';
import styled from '@emotion/styled';
import Faqs from './components/Faqs';
import ShadowDomContainer from './components/ShadowDomContainer';
import Onboarding from './components/Onboarding';
import locales from './locales';

const AppContainer = styled.div`
  --color-primary: #077AC0;
  --color-primary-light: #E1F5FF;
  --color-primary-dark: #00588A;
  --color-primary-darker: #0B3349;
  --color-white: #FFF;
  --color-black: #333333;
  --color-gray: #BDBDBD;

  --chat-container-height: 852px;
  --chat-container-width: 375px;
  --chat-footer-height: 54px;
  --chat-header-height: 60px;
  --chat-border-radius: 24px;

  margin: 0;

  * {
    font-style: normal !important;
    font-family: "Open Sans", Arial, Helvetica, ui-sans-serif, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji" !important;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  & p,
  & a,
  & a:visited {
    color: inherit;
    margin: 0;
  }

  & button {
    cursor: pointer;
  }

  .rc-collapse-content-box,
  .ac-textBlock {
    ul {
      margin-left: 0;
      padding-left: 0;
      margin-top: 0.5em;
      margin-left: 1em;
      list-style: disc;
    }

    ul li {
      -webkit-font-smoothing: antialiased;
      -moz-osx-font-smoothing: grayscale;

      font-size: 16px !important;
    }
  }

  .ac-textBlock {
    ul li {
      font-size: 14px !important;

      @media screen and (min-width: 640px) {
        font-size: 16px !important;
      }

    p {
      font-size: 14px !important;

      @media screen and (min-width: 640px) {
        font-size: 16px !important;
      }
    }
  }
`;

function App({ tokenUrl, tokenMethod, faqOnly, qnaUrl, kn, lang, onboarding = false, privacyPolicyUrl = locales(lang, 'privacy-url') }) {


  const getChatView = () => {
    if (faqOnly) {
      return <Faqs faqOnly={faqOnly} qnaUrl={qnaUrl} lang={lang} kn={kn} />
    }

    if (onboarding) {
      return <Onboarding qnaUrl={qnaUrl} lang={lang} kn={kn} />
    }

    return <Bubble qnaUrl={qnaUrl} lang={lang} kn={kn} />
  }

  return (
    <WebChatProvider privacyPolicyUrl={privacyPolicyUrl} faqOnly={faqOnly} tokenUrl={tokenUrl} tokenMethod={tokenMethod} lang={lang}>
      <ShadowDomContainer>
        <AppContainer className="app web-chat-app">
          {getChatView()}
        </AppContainer>
      </ShadowDomContainer>
    </WebChatProvider>
  );
}

export default App;
